import { Link } from "react-router-dom";

const policyTextBeforeTable = `(сайт https://thefeels.ru/)
(утверждена в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных»)

1. Общие положения
1.1. Настоящая Политика обработки персональных данных (далее — Политика) разработана в соответствии с Конституцией Российской Федерации, Гражданским кодексом РФ, Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных» (далее — Закон), Федеральным законом от 27.07.2006 № 149-ФЗ «Об информации, информационных технологиях и о защите информации», иными нормативными правовыми актами РФ и определяет цели, принципы, порядок и условия обработки персональных данных посетителей сайта https://thefeels.ru/ (далее — Сайт) и клиентов Индивидуального предпринимателя Тращевского Филиппа Владимировича (далее — Оператор).
1.2. Политика является общедоступным документом, регламентирующим деятельность Оператора в качестве оператора персональных данных. Политика размещается в свободном доступе в сети Интернет по постоянному адресу: https://thefeels.ru/policy, а также может быть предоставлена по первому требованию заинтересованных лиц и уполномоченных органов.
1.3. Основные понятия:
персональные данные (ПДн) — любая информация, относящаяся к прямо или косвенно определенному или определяемому физическому лицу (субъекту персональных данных);
Оператор — ИП Тращевский Филипп Владимирович (ОГРНИП 321784700079246, ИНН 784804090474), самостоятельно организующий обработку ПДн;
обработка ПДн — любое действие (операция) или совокупность действий с ПДн, включая сбор, запись, систематизацию, накопление, хранение, уточнение, извлечение, использование, передачу, обезличивание, блокирование, удаление, уничтожение;
субъект ПДн — физическое лицо (посетитель Сайта, клиент, заказчик бронирования);
файлы cookie — небольшие текстовые файлы, сохраняемые на устройстве субъекта при посещении Сайта, обеспечивающие его функционирование.
1.4. Сведения об Операторе:
`;
const policyTextAfterTable = `
1.5. Настоящая Политика утверждается Оператором и может пересматриваться по мере изменения законодательства Российской Федерации в области персональных данных, а также при изменении внутренних процессов Оператора. Новая редакция Политики вступает в силу с момента её опубликования на Сайте, если иное не предусмотрено самой редакцией.
1.6. Настоящая Политика не применяется к сайтам и сервисам третьих лиц, ссылки на которые могут быть размещены на Сайте Оператора. Оператор не несёт ответственности за действия третьих лиц, получивших доступ к персональным данным субъекта через указанные ресурсы.

2. Правовые основания и принципы обработки персональных данных
2.1. Правовыми основаниями обработки персональных данных Оператором являются:
•	Конституция Российской Федерации;
•	Гражданский кодекс Российской Федерации;
•	Федеральный закон от 27.07.2006 № 152-ФЗ «О персональных данных»;
•	Федеральный закон от 27.07.2006 № 149-ФЗ «Об информации, информационных технологиях и о защите информации»;
•	Постановление Правительства РФ от 15.09.2008 № 687;
•	Постановление Правительства РФ от 01.11.2012 № 1119;
•	согласие субъекта персональных данных на обработку его персональных данных, выраженное путём проставления отметки в соответствующем чекбоксе на Сайте и последующего нажатия кнопки отправки формы (конклюдентное действие), а для файлов cookie — путём продолжения использования Сайта после уведомления об их использовании;
•	требования законодательства Российской Федерации (в случаях, когда обработка обязательна).
2.2. Обработка персональных данных осуществляется на основе следующих принципов:
•	законность целей и способов обработки, добросовестность и справедливость;
•	ограничение обработки достижением конкретных, заранее определенных и законных целей;
•	недопустимость объединения баз данных, содержащих персональные данные, обработка которых осуществляется в целях, несовместимых между собой;
•	соответствие объёма и содержания обрабатываемых персональных данных заявленным целям (минимизация);
•	обеспечение точности, достаточности, а при необходимости — актуальности;
•	хранение в форме, позволяющей определить субъекта, не дольше, чем этого требуют цели обработки;
•	уничтожение либо обезличивание по достижении целей или утрате необходимости.

3. Категории субъектов и состав обрабатываемых персональных данных
3.1. Оператор обрабатывает персональные данные следующих категорий субъектов:
•	посетители Сайта, заполняющие форму бронирования бильярдного стола;
•	клиенты, оформившие бронирование;
•	иные лица, обратившиеся к Оператору.
3.2. Состав данных, добровольно предоставляемых субъектом через форму бронирования на Сайте:
•	фамилия, имя, отчество (при указании);
•	номер телефона.
Данные являются минимально необходимыми для идентификации клиента, связи с ним для подтверждения бронирования и оказания услуги. Все поля, обязательные для заполнения, помечены на Сайте. Отказ от предоставления обязательных сведений влечёт невозможность обработки заявки и бронирования.
3.3. Автоматически собираемые технические данные (при посещении Сайта):
Сайт использует только строго необходимые технические файлы cookie, которые обеспечивают его функционирование и безопасность. Никакие аналитические, маркетинговые или иные отслеживающие файлы cookie не применяются. Веб-аналитика на Сайте не используется.
Собираемые технические данные:
•	идентификатор сессии;
•	IP-адрес (в обезличенном виде, только для обеспечения работы сервера);
•	данные о браузере и операционной системе (техническая необходимость).
3.4. Специальные категории персональных данных, а также биометрические данные Оператором не обрабатываются.

4. Цели обработки персональных данных
4.1. Обработка ПДн, добровольно предоставленных субъектом, осуществляется для следующих законных целей:
`;

const policyTextAfterTable_2 = `
4.2. Обработка технических данных (строго необходимые cookie) осуществляется исключительно для обеспечения стабильной и безопасной работы Сайта. Никакие данные не используются для аналитики, маркетинга или отслеживания поведения пользователей.
4.3. Использование персональных данных в иных целях, не предусмотренных настоящей Политикой, не допускается.

5. Порядок сбора и предоставления согласия
5.1. Сбор через форму бронирования: субъект заполняет поля «ФИО» и «Номер телефона», проставляет отметку в чекбоксе «Я даю согласие на обработку персональных данных» и нажимает кнопку отправки. С этого момента согласие считается полученным, и Оператор вправе обрабатывать предоставленные данные в заявленных целях.
5.2. Cookie-уведомление: при посещении Сайта субъект информируется об использовании строго необходимых технических cookie-файлов путём отображения краткого уведомления. Поскольку эти cookie не собирают информацию для аналитики или маркетинга, согласие субъекта для их использования не требуется. Субъект может в любое время запретить использование cookie в настройках браузера, однако это может повлиять на работоспособность Сайта.
5.3. Факт проставления субъектом отметки в чекбоксе и отправки формы является конклюдентным действием, равнозначным собственноручной подписи и порождающим юридические последствия.
5.4. Перед получением согласия Оператор обеспечивает субъекту возможность ознакомления с текстом настоящей Политики путём размещения гиперссылки на неё в непосредственной близости от формы бронирования.

6. Обработка, хранение и защита персональных данных
6.1. Оператор осуществляет как автоматизированную (CRM-системы, серверы электронной почты), так и неавтоматизированную (бумажные документы) обработку ПДн. Перечень действий включает: сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (в случаях, предусмотренных законом или необходимых для исполнения обязательств), обезличивание, блокирование, удаление, уничтожение.
6.2. Сроки хранения:
•	ПДн клиентов и обратившихся — в течение 3 (трех) лет после последнего взаимодействия (общий срок исковой давности), если иное не предусмотрено законом;
•	файлы cookie — см. раздел 11;
•	по достижении целей обработки данные уничтожаются или обезличиваются в течение 30 (тридцати) календарных дней.
6.3. Меры по обеспечению безопасности:
•	назначение ответственного за организацию обработки ПДн;
•	ограничение круга лиц, допущенных к ПДн, и подписание ими обязательств о неразглашении;
•	использование парольной защиты, антивирусного ПО, защищённого протокола HTTPS;
•	регулярное обновление программного обеспечения;
•	хранение бумажных носителей в запираемых шкафах;
•	проведение внутреннего аудита соответствия обработки требованиям законодательства.

7. Локализация баз данных
7.1. В соответствии с частью 5 статьи 18 Федерального закона № 152-ФЗ Оператор обеспечивает запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение персональных данных граждан Российской Федерации с использованием баз данных, физически расположенных на территории Российской Федерации.
7.2. При выборе поставщиков программного обеспечения (хостинг, CRM-системы, облачные сервисы) Оператор отдаёт предпочтение тем, чьи серверы находятся на территории РФ, и фиксирует соответствующие гарантии в договорах.
7.3. Трансграничная передача персональных данных Оператором не осуществляется.

8. Передача данных третьим лицам
8.1. Оператор вправе передавать персональные данные третьим лицам исключительно в следующих случаях:
•	при наличии отдельного письменного согласия субъекта;
•	если это необходимо для исполнения обязательств перед субъектом (например, платёжному сервису для обработки оплаты бронирования);
•	по мотивированному требованию уполномоченных государственных органов.
8.2. Продажа или иная передача ПДн в маркетинговых целях без согласия субъекта запрещена.

9. Права и обязанности субъектов персональных данных
9.1. Субъект ПДн имеет право:
•	на получение сведений, касающихся обработки его ПДн;
•	на уточнение, блокирование или уничтожение неполных, устаревших, неточных, незаконно полученных или не являющихся необходимыми данных;
•	на отзыв согласия на обработку в любой момент (не затрагивает законность обработки, произведённой до отзыва);
•	на обжалование действий или бездействия Оператора в Роскомнадзоре либо в суде.
9.2. Для реализации своих прав субъект направляет письменный запрос на адрес электронной почты, указанный на Сайте, или почтовым отправлением. Запрос должен содержать идентифицирующие сведения и суть требования. Ответ предоставляется в срок не более 10 (десяти) рабочих дней.

10. Обязанности Оператора
Оператор обязуется:
•	обрабатывать ПДн строго в соответствии с Законом и настоящей Политикой;
•	не раскрывать персональные данные третьим лицам без согласия субъекта, за исключением случаев, предусмотренных законом;
•	принимать необходимые правовые, организационные и технические меры для защиты данных;
•	уведомить Роскомнадзор о начале обработки (если это предусмотрено ст. 22 Закона);
•	в случае выявления неправомерной обработки прекратить её в течение 3 рабочих дней, а при невозможности — уничтожить данные в течение 10 рабочих дней;
•	по достижении целей или при отзыве согласия уничтожить данные в течение 30 дней.

11. Использование файлов cookie
11.1. Сайт https://thefeels.ru/ использует исключительно строго необходимые технические файлы cookie. Никакие аналитические, маркетинговые или иные отслеживающие файлы cookie не применяются. Веб-аналитика на Сайте не используется.
11.2. Категория используемых cookie-файлов:
`;

const policyTextAfterTable_3 = `
11.3. При посещении Сайта субъект уведомляется об использовании технических cookie путём отображения информационного сообщения. Поскольку указанные cookie не собирают персональную информацию и не используются для отслеживания, согласие субъекта не требуется.
11.4. Субъект может в любое время отключить использование cookie в настройках своего браузера, однако это может повлиять на корректность работы Сайта.
11.5. Срок хранения cookie: строго необходимые cookie хранятся в течение сессии или до закрытия браузера.

12. Порядок уничтожения персональных данных
12.1. Уничтожение производится по достижении целей, истечении срока хранения, требованию субъекта или в иных законных случаях.
12.2. Бумажные носители уничтожаются измельчением с составлением акта; электронные данные — гарантированным удалением с составлением акта.

13. Уведомление Роскомнадзора
Оператор обязан подать уведомление об обработке персональных данных в территориальный орган Роскомнадзора до начала фактической обработки, за исключением случаев, предусмотренных ч. 2 ст. 22 Федерального закона № 152-ФЗ.

14. Заключительные положения
14.1. Настоящая Политика вступает в силу с момента её утверждения и размещается на Сайте по постоянному адресу: https://thefeels.ru/policy.
14.2. Оператор вправе вносить изменения в Политику. Новая редакция вступает в силу с момента опубликования на Сайте.
14.3. Неурегулированные вопросы разрешаются в соответствии с законодательством Российской Федерации.

Реквизиты Оператора:
ИП Тращевский Филипп Владимирович
ИНН: 784804090474
ОГРНИП: 321784700079246
Сайт: https://thefeels.ru/
`;

const PrivacyPage = () => {
  return (
    <div className="privacy-page">
      <div className="privacy-page-header">
        <Link to="/" className="back-button privacy-back">
          ✕
        </Link>

        <h1>Политика конфиденциальности</h1>
      </div>

      <div className="info-card privacy-card">
        <h2 className="info-section-title">
          Политика в отношении обработки персональных данных
        </h2>

        <div className="policy-content" style={{ whiteSpace: "pre-wrap" }}>
          {policyTextBeforeTable}
        </div>

       <div className="policy-table-wrapper">
        <table className="policy-table">
          <tbody>
            <tr>
              <td>Фамилия, имя, отчество</td>
              <td>Тращевский Филипп Владимирович</td>
            </tr>
            <tr>
              <td>Статус</td>
              <td>Индивидуальный предприниматель</td>
            </tr>
            <tr>
              <td>ИНН</td>
              <td>784804090474</td>
            </tr>
            <tr>
              <td>ОГРНИП</td>
              <td>321784700079246</td>
            </tr>
            <tr>
              <td>Адрес</td>
              <td>указан на Сайте</td>
            </tr>
            <tr>
              <td>Контактный телефон, e-mail</td>
              <td>указаны на Сайте</td>
            </tr>
          </tbody>
        </table>
       </div>

        <div className="policy-content" style={{ whiteSpace: "pre-wrap" }}>
          {policyTextAfterTable}
        </div>

	<div className="policy-table-wrapper">
        <table className="policy-table">
          <thead>
            <tr>
              <th>Цель обработки</th>
              <th>Описание</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>Бронирование бильярдного стола</td>
              <td>
                Приём и обработка заявки, связь с клиентом для подтверждения
                даты, времени и количества столов, уведомление о статусе
                бронирования
              </td>
            </tr>

            <tr>
              <td>Исполнение договора оказания услуг</td>
              <td>
                Оформление и выполнение обязательств по предоставлению услуг
                бильярдного клуба, приём оплаты (при необходимости)
              </td>
            </tr>

            <tr>
              <td>Обратная связь и поддержка</td>
              <td>
                Ответы на вопросы, обработка обращений, информирование об
                изменениях в работе клуба
              </td>
            </tr>
          </tbody>
        </table>
       </div>

        <div className="policy-content" style={{ whiteSpace: "pre-wrap" }}>
          {policyTextAfterTable_2}
        </div>

        <div className="policy-table-wrapper">
          <table className="policy-table">
            <thead>
              <tr>
                <th>Категория</th>
                <th>Назначение</th>
                <th>Примеры данных</th>
                <th>Требуется ли согласие</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>Строго необходимые (технические)</td>
                <td>
                  Обеспечивают базовую работу Сайта: навигацию, запоминание
                  заполненных форм, балансировку нагрузки, безопасность. Без них
                  Сайт не может функционировать корректно.
                </td>
                <td>Идентификатор сессии, настройки безопасности</td>
                <td>Нет (необходимы для функционирования)</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="policy-content" style={{ whiteSpace: "pre-wrap" }}>
          {policyTextAfterTable_3}
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;

